import { Space, Typography } from "antd";
import React from "react";
import AlertIcon from "../../../../assets/images/alert-triangular-outer.svg";
import "./upload-doc-alert.scss";

const { Text } = Typography;

const UploadDocAlert = () => {
  return (
    <div className="upload-doc-alert-block">
      <Space align="start" size={8}>
        {/* Custom SVG Icon */}

        <img src={AlertIcon} alt="Alert icon" width={20} height={20} />

        {/* Alert text */}
        <Text style={{ fontSize: 14, color: "#09101D", lineHeight: 1 }}>
          All the ID’s should be placed at certain gap, with a white background.
        </Text>
      </Space>
    </div>
  );
};

export default UploadDocAlert;
